/**
 * Light, dark, or whatever the device says. A property of the screen in
 * front of you, so it lives in this browser's localStorage; index.html reads
 * the same key before first paint so the page never flashes.
 */
export const THEMES = ['light', 'dark', 'system'] as const
export type Theme = (typeof THEMES)[number]
export const THEME_KEY = 'routr_theme'
export function resolveTheme(value: unknown): Theme {
  return value === 'light' || value === 'dark' ? value : 'system'
}
export const THEME_LABELS: Record<Theme, string> = { light: 'Light', dark: 'Dark', system: 'Match device' }
export function readTheme(): Theme {
  try {
    return resolveTheme(window.localStorage.getItem(THEME_KEY))
  } catch {
    return 'system'
  }
}
export function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'system') delete root.dataset.theme
  else root.dataset.theme = theme
  try {
    if (theme === 'system') window.localStorage.removeItem(THEME_KEY)
    else window.localStorage.setItem(THEME_KEY, theme)
  } catch {
    /* private mode */
  }
}
